import React from 'react';
import './General.css';


const DonationSuccess = () => {
  return (
    <div className='general-content'>
      <h1>Thanks for donating!</h1>
      <p>Your contribution is highly appreciated and will be paramount for the correct mainteinance of this project</p>
    </div>
  );
};

export default DonationSuccess;